export const Primary = '#2B2B2B';
export const Secondary = '#fff';
export const White = '#FFFFFF';
export const Gray500 = '#989898';
export const Error = '#FF4D4F';
